import { render } from "./form4.vue?vue&type=template&id=1fa60b22&scoped=true&ts=true"
import script from "./form4.vue?vue&type=script&lang=ts"
export * from "./form4.vue?vue&type=script&lang=ts"

import "./form4.vue?vue&type=style&index=0&id=1fa60b22&lang=less&scoped=true"
import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa60b22"]])

export default __exports__